<h1 class="standard-headline" style='margin-left: 20px'>{{ 'MAINMENU.TEAMS' | translate }}</h1>
<br />
<div style="overflow: visible;">
	<div style="padding: 20px; height: 100vh; width: 350px;">
		<div fxLayout="row">
			<mat-form-field appearance="outline" class="block w-full">
				<mat-label>Filter</mat-label>
				<input matInput id="filter" type="text" #filter (keyup)="filterFn(filter.value, tree.treeModel)" />
			</mat-form-field>
			<div><button mat-raised-button (click)="resetFilter(); filter.value = ''" style="margin-top: 13px; margin-left: 13px;">Clear</button></div>
		</div>
		<!--
    <tree-root #tree [nodes]="nodes" [options]="options"></tree-root>
    -->

		<div style='height: auto'>
			<tree-root #tree [nodes]="nodes" (activate)="treeSelected($event)" [options]="options">
				<ng-template #treeNodeTemplate let-node let-index="index">
					<span>{{ node.data.name }}</span>
					<img
						style="max-width: 60px; max-height: 24px; float: right; right: 0; margin-top: -20px; position: absolute; border-radius: 4px;"
						*ngIf="node.data.iconUrl"
						[src]="node.data.iconUrl"
						onerror="this.style.display='none'"
					/>
				</ng-template>
			</tree-root>
		</div>

	</div>

	<div style="height: 100vh;" @stagger fxFlex="auto">
		<div class="p-gutter" vexContainer gdColumns="1fr 1fr 1fr 1fr" gdColumns.lt-md="1fr 1fr" gdColumns.xs="1fr" gdGap="24px">
			<div *ngFor="let team of filteredTeams" class="card overflow-hidden" style='min-height: 200px; max-height:200px;'>
				<div class='flex flex-col' style='height: 100%'>
					<div class="flex-1 p-4 text-center hover:bg-hover trans-ease-out cursor-pointer relative" matRipple>
						<mat-icon size="24px" [icIcon]="icGroup"></mat-icon>

						<h3 class="title mb-1 mt-3">{{ team?.displayName }}</h3>

						<!--
										<div class="body-2 text-secondary">
											<ic-icon [icon]="icMail" class="ltr:mr-1 rtl:ml-1" inline="true"></ic-icon>
											<span>{{ team?.mail }}</span>
										</div>
						-->

						<div class="body-2 text-secondary">
							<span>{{ team?.visibility }}</span>
						</div>
					</div>

					<div class="flex-none bg-app-bar p-2" fxLayout="row" fxLayoutAlign="space-around center">
						<button *ngIf="team.mail" color="accent" class="text-secondary" (click)="sendMail(team)" mat-icon-button type="button">
							<mat-icon [icIcon]="icMail"></mat-icon>
						</button>

						<button class="text-secondary" color="accent" (click)="openTeamsLink(team)" mat-icon-button type="button">
							<mat-icon [icIcon]="icChat"></mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
